var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAe = function SvgIconAe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.782 16.173 1.044 7.08c1.3.482 2.706.746 4.174.746 5.16 0 9.558-3.256 11.253-7.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M6.782 7.827 7.826.747C9.126.264 10.532 0 12 0c5.16 0 9.558 3.257 11.253 7.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M0 12c0 5.16 3.257 9.558 7.826 11.254V.747C3.256 2.442 0 6.84 0 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAe;